const BOARD = 'BOARD';
const LIST = 'LIST';
const CARD = 'CARD';

export default {
  BOARD,
  LIST,
  CARD,
};
